import { AsciiText } from '../framework/AsciiText';
import { NanolumensCaptivateBase } from './util/NanolumensCaptivateBase';
export class NanolumensCaptivateUdp extends NanolumensCaptivateBase {
    constructor(socket, log) {
        super(log);
        this.socket = socket;
        this.log = log;
        this.ipAddress = '';
        this.port = 0;
    }
    parser(message) {
        let command = '';
        const cmdRegEx = /(\x55{7}\xc0\x01\x03\x01\xd0\x00\xd1[\S\s]{2}\x00{2}\xff{17}\x00)([\S\s]{2})/;
        const match = cmdRegEx.exec(message.message);
        if (match && match[1]) {
            const dataLength = match[2].charCodeAt(0);
            const cmdLength = match[1].length + 2 + dataLength + 1; // includes checksum
            command = `${match[1]}${match[2]}${message.message.slice(match[1].length + 2, cmdLength)}`;
        }
        return {
            address: message.address,
            message: command,
            port: message.port,
        };
    }
    onConfigure(config) {
        var _a, _b;
        super.onConfigure(config);
        this.ipAddress = (_a = config.ipAddress) !== null && _a !== void 0 ? _a : '';
        this.port = (_b = config.port) !== null && _b !== void 0 ? _b : 0;
    }
    send(bytes) {
        this.socket.send(this.ipAddress, this.port, AsciiText.decode(bytes));
    }
}
NanolumensCaptivateUdp.emulatorType = 'udpEmulator';
NanolumensCaptivateUdp.key = '-O3oQ3OSDXJY794uByGC';
